import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import s from './EventSubjects.module.scss';
import ButtonPrimary from '../ButtonPrimary/ButtonPrimary';
import { ACTION_TYPES } from '../../containers/EventListPage/EventListPage';
import { EventListPageContext } from '../../containers/EventListPage/EventListPageContext';
import { trackEventCategory } from '../../utils/dataLayer';

const EventSubjects = ({ subjects = [] }) => {
  const { state, dispatch } = useContext(EventListPageContext);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);
  const [isScrolledToStart, setIsScrolledToStart] = useState(true);
  const containerRef = useRef(null);

  const checkScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
    setIsScrolledToStart(scrollLeft <= 0);
    setIsScrolledToEnd(scrollLeft + clientWidth >= scrollWidth - 1);
  };

  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener('scroll', checkScroll);
    return () => container.removeEventListener('scroll', checkScroll);
  }, []);

  const selectCategory = (category) => {
    if (state.isInitialLoad) return;

    const excludeCategory = state.selectedCategories.includes(category.slug)
      ? category.slug
      : false;
    dispatch({
      type: ACTION_TYPES.CATEGORY_SELECTED,
      excludeCategory,
      category,
    });

    if (!state.selectedCategories.includes(category.slug)) {
      trackEventCategory(category.slug);
    }
  };

  const scrollDistance = 520;
  const scrollLeft = () =>
    containerRef.current.scrollTo({
      left: containerRef.current.scrollLeft - scrollDistance,
      behavior: 'smooth',
    });
  const scrollRight = () =>
    containerRef.current.scrollTo({
      left: containerRef.current.scrollLeft + scrollDistance,
      behavior: 'smooth',
    });

  return (
    <div className={s.Root}>
      <div className={s.Container}>
        <div
          className={classNames(s.Fade, s.FadeLeft, {
            [s.Hidden]: isScrolledToStart,
          })}
        />
        <ul className={s.List} ref={containerRef}>
          {subjects.map((category, index) => (
            <li key={index}>
              <ButtonPrimary
                size="xsmall"
                modifiers={['InlineFlex', 'NoWrap', 'EventCategory']}
                materialIcon={category.icon}
                isActive={state.selectedCategories.includes(category.slug)}
                onClick={() => selectCategory(category)}
                aria-pressed={state.selectedCategories.includes(category.slug)}>
                <span
                  className={classNames(s.CategoryText, {
                    [s.NoIcon]: !category.icon,
                  })}>
                  {category.title}
                </span>
              </ButtonPrimary>
            </li>
          ))}
        </ul>
        <div
          className={classNames(s.Fade, {
            [s.Hidden]: isScrolledToEnd,
          })}
        />
      </div>
      <div className={s.ButtonsContainer}>
        <div className={s.Divider} />
        <div
          className={classNames(s.Button, s.Prev, {
            [s.Disabled]: isScrolledToStart,
          })}>
          <ButtonPrimary
            onClick={scrollLeft}
            size="xsmall"
            modifiers={['InlineFlex', 'XsmallOnlyIcon', 'PurpleBlue']}
            icon="icon-chevron-left-white"
            aria-disabled={isScrolledToStart}
            tabIndex={isScrolledToStart ? -1 : undefined}
          />
        </div>
        <div
          className={classNames(s.Button, s.Next, {
            [s.Disabled]: isScrolledToEnd,
          })}>
          <ButtonPrimary
            onClick={scrollRight}
            size="xsmall"
            modifiers={['InlineFlex', 'XsmallOnlyIcon', 'PurpleBlue']}
            icon="icon-chevron-right-white"
            aria-disabled={isScrolledToEnd}
            tabIndex={isScrolledToEnd ? -1 : undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default EventSubjects;
